<template>
  <v-layout row class="f-s-10">
    <!--<v-flex lg8 class="p-r-0">
      <div class="data-form-xs" style="line-height: 1;">
        <v-layout row class="m-b-2">
          <v-flex class="pa-0 width-80">
            <label class="">Personal</label>
          </v-flex>
          <v-flex class="pa-0 width-diff-80">
            <v-progress-linear
              :value="currentScore.personal"
              height="6"
              :color="progressColor(loan.personalScore)"
              style="margin: 2px 0"
            ></v-progress-linear>
          </v-flex>
        </v-layout>
        <v-layout row class="m-b-2">
          <v-flex class="pa-0 width-80">
            <label class="">Employment</label>
          </v-flex>
          <v-flex class="pa-0 width-diff-80">
            <v-progress-linear
              :value="currentScore.employment"
              height="6"
              :color="progressColor(loan.employmentScore)"
              style="margin: 2px 0"
            ></v-progress-linear>
          </v-flex>
        </v-layout>
        <v-layout row class="m-b-2">
          <v-flex class="pa-0 width-80">
            <label class="">Bank Info</label>
          </v-flex>
          <v-flex class="pa-0 width-diff-80">
            <v-progress-linear
              :value="currentScore.statement"
              height="6"
              :color="progressColor(loan.bankScore)"
              style="margin: 2px 0"
            ></v-progress-linear>
          </v-flex>
        </v-layout>
        <v-layout row class="m-b-2">
          <v-flex class="pa-0 width-80">
            <label class="">Bank Records</label>
          </v-flex>
          <v-flex class="pa-0 width-diff-80">
            <v-progress-linear
              :value="currentScore.bank"
              height="6"
              :color="progressColor(loan.statementScore)"
              style="margin: 2px 0"
            ></v-progress-linear>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex class="pa-0 width-80">
            <label class="">Details</label>
          </v-flex>
          <v-flex class="pa-0 width-diff-80">
            <v-progress-linear
              :value="currentScore.personal"
              height="6"
              :color="progressColor(loan.paymentScore)"
              style="margin: 2px 0"
            ></v-progress-linear>
          </v-flex>
        </v-layout>
      </div>
    </v-flex>-->
    <v-flex lg12 class="text-center">
      <span
        :class="
          `${progressColor(loan.totalScore)}--text bg-${progressColor(loan.totalScore)}-transparent-4`
        "
        style="margin-right: 10px"
        class="total-score"
        >{{ assist.tool.fieldRender(loan, '{totalScore}') }}</span
      >
    </v-flex>
  </v-layout>
</template>

<script>
import { OriginationApi } from '@/api/pandaria'
import { Tool } from '@/util/index'

export default {
  name: 'application-detail-quality-evaluation',
  props: {
    loan: Object
  },
  data () {
    return {
      assist: {
        tool: new Tool()
      },
      currentScore: {
        personal: 0,
        employment: 0,
        bank: 0,
        statement: 0,
        paymentOption: 0
      }
    }
  },
  computed: {
    loanId () {
      return this.loan.id
    }
  },
  watch: {
    loanId (val) {
      this.appendFeatureData(val)
    }
  },
  destroyed () {
    this.$eventBus.$off('updateLoanScore')
  },
  mounted () {
    this.$eventBus.$on('updateLoanScore', (target) => {
      this.loan.totalScore = target.totalScore
      this.$forceUpdate()
    })
  },
  methods: {
    progressColor (value) {
      if (value <= 4 || value === undefined) {
        return 'red'
      } else if (value > 4 && value <= 7) {
        return 'orange'
      } else if (value > 7 && value <= 10) {
        return 'teal'
      } else {
        return 'cyan'
      }
    },
    appendFeatureData (loanId) {
      const $this = this
      const request = {
        loanId: loanId,
        feature: 'QUALITY'
      }
      OriginationApi.getLoanByIdAndFeature(request, function (result) {
        $this.$eventBus.$emit('initLoanScore', result)
        Object.assign($this.loan, result)
      })
    }
  }
}
</script>

<style lang="css" scoped>
.total-score {
  display: block;
  font-size: 30px;
  margin: 0 auto;
  text-align: center;
  width: 68px;
  height: 56px;
  line-height: 56px;
  border-radius: 4px;
}
</style>
